import store from '@/store/store';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';

class QuadroGeralVinculoController {
  public static async getQuadroGeralVinculo(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const estrutura: Estrutura = store.getters.estruturaGerencialAtual
    const nrEstrutura = estrutura.NRESTRUTURAM;

    const nrPeriodo = store.getters.getNrperiodoApuracaoAtual;

    const route = 'getQuadroGeralVinculo';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESTRUTURAM: nrEstrutura,
      NRPERIODOAPURACAO: nrPeriodo,
    };

    const response = await HttpRequest.get(route, params, showLoading);

    if (response.data.messages) {
      const errorMessage = response.data.messages[0].message;
      throw new ExpectedError(errorMessage);
    }

    const quadroGeralVinculo: any[] = response.data.dataset.data;

    return quadroGeralVinculo;
  }

}

export default QuadroGeralVinculoController;
